// Shared by the caregiver Backgrounds tab and the create-caregiver wizard:
// how their form values map to and from the Backgrounds endpoints.

// Each upload area and the backend document_type its files are stored under.
export const backgroundDocumentSections = [
    {name: 'governmentIds', documentType: 'government_id'},
    {name: 'criminalRecords', documentType: 'background_check'},
    {name: 'licenses', documentType: 'license'},
]

export const emptyBackgrounds = {governmentIds: [], criminalRecords: [], workExperiences: [], licenses: []}

export const documentToEntry = doc => ({
    id: doc.id,
    documentId: doc.id,
    name: doc.file_name,
    size: doc.file_size_bytes,
    url: doc.url,
    category: doc.category ?? '',
    progress: 100,
})

export const experienceToEntry = experience => ({
    id: experience.id,
    serverId: experience.id,
    jobTitle: experience.job_title,
    company: experience.company,
    startMonth: String(experience.start_month),
    startYear: String(experience.start_year),
    currentlyWorking: experience.is_current,
    endMonth: experience.end_month ? String(experience.end_month) : '',
    endYear: experience.end_year ? String(experience.end_year) : '',
})

export const entryToExperience = entry => ({
    id: entry.serverId,
    job_title: entry.jobTitle,
    company: entry.company,
    start_month: Number(entry.startMonth),
    start_year: Number(entry.startYear),
    is_current: !!entry.currentlyWorking,
    end_month: entry.currentlyWorking ? undefined : Number(entry.endMonth),
    end_year: entry.currentlyWorking ? undefined : Number(entry.endYear),
})

export const toBackgroundValues = (documents, experiences) => {
    const values = {...emptyBackgrounds, workExperiences: experiences.map(experienceToEntry)}
    for (const {name, documentType} of backgroundDocumentSections) {
        values[name] = documents.filter(doc => doc.document_type === documentType).map(documentToEntry)
    }
    return values
}

// Marks every document without a category on a react-hook-form form, and
// returns whether all of them have one. Nothing should be sent until it does.
export const validateDocumentCategories = form => {
    let valid = true
    for (const {name} of backgroundDocumentSections) {
        const entries = form.getValues(name) ?? []
        if (entries.some(entry => !entry.category)) {
            valid = false
            form.setValue(
                name,
                entries.map(entry => ({...entry, categoryError: !entry.category})),
            )
        }
    }
    return valid
}

// The multipart body for uploading one picked file.
export const documentUploadFormData = (entry, documentType) => {
    const formData = new FormData()
    formData.append('file', entry.file)
    formData.append('document_type', documentType)
    formData.append('category', entry.category)
    return formData
}
